var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('v-select',{attrs:{"items":_vm.parceiros,"item-text":"trade_name","return-object":"","label":"Selecionar parceiro","dense":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }